const cholesterolRange = {
  Unknown: 1,
  VeryHigh: 2,
  Between: 3,
  Higher: 4
}

export default cholesterolRange;